module.exports = __webpack_public_path__ + "static/media/016.0adeaccc.jpg";